module.exports = __webpack_public_path__ + "static/mobile_mapping-b6a75d6daf28ee95135b34eaf3d02e46.jpg";